var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1612.95 1421H1712V1684H1610.06V1614.18H1599V1458.24H1612.95V1421Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M1863 1421H1712V1684H1863V1421Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M2113 1421H1863V1684H2113V1421Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M2361.98 837H3106V2026H2338V1427.49H2340.85V1414.44H2593.5V1313.1H2361.98V837Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "1_1",
    d: "M2113 1764H1863V2026H2113V1764Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "1_2",
    d: "M1863 1764H1632V2026H1863V1764Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "1_3",
    d: "M1632 1764H1401V2026H1632V1764Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "1_4",
    d: "M1098.65 1913.13L1341.15 1754H1401V2026H1172.9L1098.65 1913.13Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "1_5",
    d: "M1298.06 1782.3L1163.62 1577.28L964.179 1708.07L1098.62 1913.08L1298.06 1782.3Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "1_6",
    d: "M1048 1344.5L1104.63 1429.7L1126.68 1460.77L1116.18 1467.77L1130.21 1488.32L1157.71 1468.82L1204.67 1540.9L959.878 1701.42L826.994 1489.51L1048 1344.5Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "1_7",
    d: "M1047.88 1344.56L928.235 1162.11L707.18 1307.07L826.824 1489.52L1047.88 1344.56Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "1_8",
    d: "M928.135 1161.97L801.344 968.621L580.193 1113.64L706.984 1306.99L928.135 1161.97Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "1_9",
    d: "M801.244 968.689L664.885 760.748L443.734 905.77L580.093 1113.71L801.244 968.689Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "1_10",
    d: "M1087.01 783.297L949.863 574.156L730.106 718.265L867.252 927.405L1087.01 783.297Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "1_11",
    d: "M1214.4 977.042L1087.15 783L867.207 927.23L994.452 1121.27L1214.4 977.042Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "1_12",
    d: "M1361.91 1143.65L1498.12 1350.62L1268.93 1500.75L1228.63 1437.77L1204.62 1453.26L1106.44 1303.04L1333.87 1154.95L1337.48 1160.12L1361.91 1143.65Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor1);
export default __webpack_public_path__ + "static/media/select_floor_1.3222c8e2731e36b4c1f09901ac68e355.svg";
export { ForwardRef as ReactComponent };